export default __webpack_public_path__ + "a9a9429362468327825a2c8f9c9eaf14.woff";